// // frontend/src/pages/CandidateBatches.jsx
// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

// // Format time helper
// function formatTime(t) {
//   if (!t) return "";
//   const s = String(t);
//   return s.length >= 5 ? s.slice(0, 5) : s;
// }

// function capitalize(x) {
//   if (!x) return "";
//   return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
// }

// export default function CandidateBatches() {
//   const [batches, setBatches] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [processingBatch, setProcessingBatch] = useState(null); // batch id being processed
//   const [error, setError] = useState("");

//   const navigate = useNavigate();
//   const tokenRef = useRef(localStorage.getItem("candidateToken") || "");

//   const headersFor = useCallback(() => {
//     const t = tokenRef.current || localStorage.getItem("candidateToken") || "";
//     if (t) tokenRef.current = t;
//     return t ? { Authorization: `Bearer ${t}` } : {};
//   }, []);

//   async function load() {
//     setLoading(true);
//     setError("");

//     const headers = headersFor();
//     if (!headers.Authorization) {
//       navigate("/candidate");
//       return;
//     }

//     try {
//       const res = await axios.get(`${API}/api/batches`, { headers, timeout: 15000 });
//       setBatches(res.data.batches || []);
//     } catch (err) {
//       console.error("load batches error:", err);
//       setError(err?.response?.data?.error || err?.message || "Could not load batches");
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     load();
//   }, []);

//   // enroll one slot (existing endpoint)
//   async function enrollSlot(slotId) {
//     const headers = headersFor();
//     try {
//       await axios.post(`${API}/api/batches/slots/${slotId}/enroll`, {}, { headers, timeout: 20000 });
//       return true;
//     } catch (err) {
//       throw err;
//     }
//   }

//   async function enrollWholeBatch(batch) {
//     const headers = headersFor();
//     if (!headers.Authorization) {
//       navigate("/candidate");
//       return;
//     }

//     const slots = Array.isArray(batch.slots) ? batch.slots : [];
//     if (!slots.length) {
//       alert("No slots available for this batch.");
//       return;
//     }

//     if (!window.confirm(`Enroll in entire "${batch.title || `Batch ${batch.id}`}" (all classes)?`)) return;

//     setProcessingBatch(batch.id);
//     try {
//       for (const s of slots) {
//         // skip if already enrolled by current user
//         if (s.enrolled_by_current) continue;

//         // skip if full
//         const capacity = s.capacity ?? s.capacity_override ?? batch.capacity ?? 25;
//         const enrolled = s.enrolled ?? 0;
//         if (enrolled >= capacity) {
//           console.warn(`slot ${s.id} is full; skipping`);
//           continue;
//         }

//         // enroll this slot (sequential)
//         await enrollSlot(s.id);
//       }

//       alert("Enrolled in batch successfully.");
//       await load();
//     } catch (err) {
//       console.error("batch enroll error:", err);
//       const msg = err?.response?.data?.error || err?.message || "Batch enrollment failed";
//       alert(msg);
//       await load();
//     } finally {
//       setProcessingBatch(null);
//     }
//   }

//   if (loading) return <div className="container my-5">Loading...</div>;

//   return (
//     <div className="container my-5">
//       {error && <div className="alert alert-danger mb-3">{error}</div>}

//       <h2 className="mb-4">Available Batches & Slots</h2>

//       {batches.length === 0 && <div>No batches available.</div>}

//       {batches.map((batch) => {
//         const batchName = batch.title || batch.name || `Batch ${batch.id}`;
//         const isEnrolled = !!batch.enrolled_by_current;

//         return (
//           <div key={batch.id} className="border rounded p-3 my-4 shadow-sm">
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//               <h4 className="mb-0">{batchName}</h4>

//               <div>
//                 {isEnrolled ? (
//                   <button className="btn btn-outline-secondary" disabled>Enrolled</button>
//                 ) : (
//                   <button
//                     className="btn btn-primary"
//                     onClick={() => enrollWholeBatch(batch)}
//                     disabled={processingBatch != null}
//                   >
//                     {processingBatch === batch.id ? "Processing..." : "Enroll in Batch"}
//                   </button>
//                 )}
//               </div>
//             </div>

//             {batch.description && <p className="text-muted mt-2" style={{ whiteSpace: "pre-line" }}>{batch.description}</p>}

//             <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginTop: 12 }}>
//               {(batch.slots || []).map((s) => {
//                 const daysArr = Array.isArray(s.day_of_week) && s.day_of_week.length
//                   ? s.day_of_week
//                   : Array.isArray(s.days) ? s.days : [];
//                 const daysLabel = daysArr.map(capitalize).join(", ");

//                 const st = formatTime(s.start_time);
//                 const et = formatTime(s.end_time);
//                 const timeLabel = st && et ? `${st} - ${et}` : (s.slot_label || "-");

//                 const capacity = s.capacity ?? s.capacity_override ?? batch.capacity ?? 25;
//                 const enrolled = s.enrolled ?? 0;
//                 const free = capacity - enrolled;

//                 return (
//                   <div key={s.id} style={{ flex: "0 0 calc(33.333% - 1rem)", minWidth: 260 }}>
//                     <div className="border rounded p-3 h-100">
//                       <div className="fw-semibold">{s.class_name || s.name || "Class"}</div>
//                       <div className="text-muted small">Days: {daysLabel || "—"}</div>
//                       <div className="small mt-2">Time: {timeLabel}</div>
//                       <div className="small mt-2">Capacity: {capacity} | Enrolled: {enrolled}</div>
//                       <div className="small text-muted mt-1">{free > 0 ? `${free} seats left` : "Full"}</div>
//                       {s.enrolled_by_current && <div className="badge bg-success mt-2">You enrolled</div>}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// }


// frontend/src/pages/CandidateBatches.jsx
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api"; // ✅ CHANGED

// Format time helper
function formatTime(t) {
  if (!t) return "";
  const s = String(t);
  return s.length >= 5 ? s.slice(0, 5) : s;
}

function capitalize(x) {
  if (!x) return "";
  return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
}

export default function CandidateBatches() {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingBatch, setProcessingBatch] = useState(null);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const tokenRef = useRef(localStorage.getItem("candidateToken") || "");

  const headersFor = useCallback(() => {
    const t = tokenRef.current || localStorage.getItem("candidateToken") || "";
    if (t) tokenRef.current = t;
    return t ? { Authorization: `Bearer ${t}` } : {};
  }, []);

  async function load() {
    setLoading(true);
    setError("");

    const token = tokenRef.current || localStorage.getItem("candidateToken");

    if (!token) {
      navigate("/candidate");
      return;
    }

    try {
      // ✅ CHANGED
      const res = await api.get("/api/batches");

      setBatches(res.data.batches || []);
    } catch (err) {
      console.error("load batches error:", err);
      setError(err?.response?.data?.error || err?.message || "Could not load batches");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  // enroll one slot
  async function enrollSlot(slotId) {
    try {
      // ✅ CHANGED
      await api.post(`/api/batches/slots/${slotId}/enroll`);
      return true;
    } catch (err) {
      throw err;
    }
  }

  async function enrollWholeBatch(batch) {
    const token = tokenRef.current || localStorage.getItem("candidateToken");

    if (!token) {
      navigate("/candidate");
      return;
    }

    const slots = Array.isArray(batch.slots) ? batch.slots : [];

    if (!slots.length) {
      alert("No slots available for this batch.");
      return;
    }

    if (!window.confirm(`Enroll in entire "${batch.title || `Batch ${batch.id}`}" (all classes)?`)) return;

    setProcessingBatch(batch.id);

    try {
      for (const s of slots) {
        if (s.enrolled_by_current) continue;

        const capacity = s.capacity ?? s.capacity_override ?? batch.capacity ?? 25;
        const enrolled = s.enrolled ?? 0;

        if (enrolled >= capacity) {
          console.warn(`slot ${s.id} is full; skipping`);
          continue;
        }

        await enrollSlot(s.id);
      }

      alert("Enrolled in batch successfully.");
      await load();

    } catch (err) {
      console.error("batch enroll error:", err);
      const msg = err?.response?.data?.error || err?.message || "Batch enrollment failed";
      alert(msg);
      await load();
    } finally {
      setProcessingBatch(null);
    }
  }

  if (loading) return <div className="container my-5">Loading...</div>;

  return (
    <div className="container my-5">
      {error && <div className="alert alert-danger mb-3">{error}</div>}

      <h2 className="mb-4">Available Batches & Slots</h2>

      {batches.length === 0 && <div>No batches available.</div>}

      {batches.map((batch) => {
        const batchName = batch.title || batch.name || `Batch ${batch.id}`;
        const isEnrolled = !!batch.enrolled_by_current;

        return (
          <div key={batch.id} className="border rounded p-3 my-4 shadow-sm">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h4 className="mb-0">{batchName}</h4>

              <div>
                {isEnrolled ? (
                  <button className="btn btn-outline-secondary" disabled>Enrolled</button>
                ) : (
                  <button
                    className="btn btn-primary"
                    onClick={() => enrollWholeBatch(batch)}
                    disabled={processingBatch != null}
                  >
                    {processingBatch === batch.id ? "Processing..." : "Enroll in Batch"}
                  </button>
                )}
              </div>
            </div>

            {batch.description && (
              <p className="text-muted mt-2" style={{ whiteSpace: "pre-line" }}>
                {batch.description}
              </p>
            )}

            <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginTop: 12 }}>
              {(batch.slots || []).map((s) => {
                const daysArr =
                  Array.isArray(s.day_of_week) && s.day_of_week.length
                    ? s.day_of_week
                    : Array.isArray(s.days)
                    ? s.days
                    : [];

                const daysLabel = daysArr.map(capitalize).join(", ");

                const st = formatTime(s.start_time);
                const et = formatTime(s.end_time);
                const timeLabel = st && et ? `${st} - ${et}` : (s.slot_label || "-");

                const capacity = s.capacity ?? s.capacity_override ?? batch.capacity ?? 25;
                const enrolled = s.enrolled ?? 0;
                const free = capacity - enrolled;

                return (
                  <div key={s.id} style={{ flex: "0 0 calc(33.333% - 1rem)", minWidth: 260 }}>
                    <div className="border rounded p-3 h-100">
                      <div className="fw-semibold">{s.class_name || s.name || "Class"}</div>
                      <div className="text-muted small">Days: {daysLabel || "—"}</div>
                      <div className="small mt-2">Time: {timeLabel}</div>
                      <div className="small mt-2">
                        Capacity: {capacity} | Enrolled: {enrolled}
                      </div>
                      <div className="small text-muted mt-1">
                        {free > 0 ? `${free} seats left` : "Full"}
                      </div>
                      {s.enrolled_by_current && (
                        <div className="badge bg-success mt-2">You enrolled</div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}